import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { apiClient, type PageEntity } from '@/libs/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { type PermanentPlanSlotRow, PlanSlotsSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/plan-slots/'
)({
  validateSearch: (search) => parse(PlanSlotsSearchSchema, search),
  loaderDeps: ({ search }) => ({ search }),
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)

    // status 未指定の場合は 'active' を常に補完する
    // （初回アクセス・拠点切替で status が欠けるケース両方をカバー）
    const statusNeeded = search.status === undefined
    const dcIdMismatch = search.dcId !== selectedDcId

    if (statusNeeded || dcIdMismatch) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          ...(statusNeeded && { status: 'active' as const }),
          ...(dcIdMismatch && { dcId: selectedDcId })
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps: { search }
  }) => {
    const dcId = search.dcId
    if (dcId == null) {
      return {
        planSlots: [] as PermanentPlanSlotRow[],
        pagination: null as PageEntity | null
      }
    }

    const res = await apiClient._tenant(tenantKey).plan_slots.permanent.get({
      query: {
        dcId,
        status: search.status,
        partnerId: search.partnerId,
        subPartnerId: search.subPartnerId,
        truckName: search.truckName,
        page: search.page,
        take: search.take
      },
      config: { signal: abortController.signal }
    })
    const envelope = res.body as unknown as {
      data: PermanentPlanSlotRow[]
      pagination: PageEntity | null
    }

    return {
      planSlots: envelope.data ?? [],
      pagination: envelope.pagination ?? null
    }
  }
})
